import type { StreamType } from '~/modules/artist-roster/components/LineGraph/LineGraph';
import { BarChartTooltip } from '~/modules/artist-roster/pages/track-details/components/BarChartTooltip';
import type {
  AgeRangeData,
  DemographicData,
} from '~/modules/artist-roster/pages/track-details/mockData/mockData';
import {
  genderNames,
  getRandomSegments,
} from '~/modules/artist-roster/pages/track-details/mockData/mockData';

export interface DemographicsTooltipProps {
  ageRange: keyof DemographicData;
  ageRangeData: AgeRangeData;
  totalStreams: number;
  streamType: StreamType;
}

export function DemographicsTooltip({
  ageRange,
  ageRangeData,
  totalStreams,
  streamType,
}: DemographicsTooltipProps) {
  const randomSegments = getRandomSegments();
  const genderBreakdown = genderNames.slice(0).map((gender, index) => ({
    label: gender,
    value: randomSegments[index - 1],
  }));

  return (
    <BarChartTooltip
      header={ageRange.toString()}
      data={ageRangeData}
      totalStreams={totalStreams}
      streamType={streamType}
      breakdown={genderBreakdown}
    />
  );
}

DemographicsTooltip.displayName = 'DemographicsTooltip';
